import PropTypes from 'prop-types';
/**
 * Used to show one children when the toogle is true or two children when toogle is false.
 *
 * @param {bool} toogle - receive toogle to show a component in position 1 or 2
 * @param {object} childrens - Receive two components
 */

const SwitchComponent = ({ toogle, children }) => {
  const [firstComponent, secondComponent] = Array.isArray(children)
    ? children
    : [children];
  return <>{toogle ? firstComponent : secondComponent}</>;
};

SwitchComponent.propTypes = {
  toogle: PropTypes.bool,
  children: PropTypes.any,
};

export default SwitchComponent;
